import {Component} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {LoanApplicationService} from '../../loan-application.service';

@Component({
  selector: 'bb-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
})
export class ContactDetailsComponent {
  personal_info = this.loan.form.get('personal_info');
  validating = Observable
    .combineLatest(
      this.personal_info.get('email_addresses').statusChanges.startWith(null),
      this.personal_info.get('mobile_numbers').statusChanges.startWith(null),
      this.personal_info.get('landline_numbers').statusChanges.startWith(null))
    .map((statuses: string[]) => statuses.includes('PENDING'));
  invalidOrBusy = this.validating
    .startWith(false)
    .map(isValidating => isValidating
      || this.personal_info.get('email_addresses').invalid
      || this.personal_info.get('mobile_numbers').invalid
      || this.personal_info.get('landline_numbers').invalid);

  constructor(public loan: LoanApplicationService) {
  }
}
